import { render, staticRenderFns } from "./NavbarHub.vue?vue&type=template&id=1938e3c2&"
import script from "./NavbarHub.vue?vue&type=script&lang=js&"
export * from "./NavbarHub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports